var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownArrowBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 13a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h10a3 3 0 013 3v10z",
    fill: "#3273FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.115l1.886-1.886.943.942L8 10 5.172 7.171l.943-.942L8 8.115z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/dropdown-arrow-blue.svg";
export { SvgDropdownArrowBlue as ReactComponent };